<template>
	<!-- entry user-->
		  <div class="modal fade" id="myModal" tabindex="-1" role="dialog">
			  <div class="modal-dialog">
				  <!-- Modal content-->
				  <div class="modal-content dir-rtl">
						  <div class="modal-body ">
						  <h3 class="agileinfo_sign" style="display:inline-block">وارد شوید</h3>
						  <button type="button" class="btn-close" data-bs-dismiss="modal" style="float:left" id="myModalCloseBTN"></button>
							  <form autocomplete="on">
								  <div class="form-group " style="margin-top:25px	">
									  <input class="form-control dir-rtl username"  type="text" v-model="username"  placeholder="شماره همراه" style="height: 49px;margin-bottom: 40px;"  name="username">
									  <div class="form-group form-group-lg search-input" style="margin-bottom: 0px;width: 100%;">
										  <label>
											  <i class="bi bi-eye" aria-hidden="true" style="cursor: pointer;" @click="passwordTextFunc" v-if="passwordTextFlag == 'password'"></i>
											  <i class="bi bi-eye-slash" aria-hidden="true" style="cursor: pointer;" @click="passwordTextFunc" v-else></i>
										  </label>
										  <input class="form-control dir-rtl password pr-3" :type="passwordTextFlag" v-model="password" autocomplete="off" placeholder="رمز عبور"  style="height: 49px;font-size: 1rem;" name="password">
									  </div>
									  <div class="form-check mt-2">
										  <input class="form-check-input" type="checkbox" id="rememberInput" checked="true">
										  <label class="form-check-label" >
											  مرا به خاطر بسپار
										  </label>
									  </div>
  
										<span style="color:red">{{validMessage}}</span>
									  <button type="button" class="btn btn-primary valid-btn my-1 w-100" @click="entryUser" v-if="finallFlag">ورود</button>
                    <button v-if="!finallFlag" class="btn btn-primary valid-btn my-1 w-100" disabled>
							      <div class="spinner-border text-light" role="status" style="vertical-align: middle;margin-left: 10px;width: 20px;height: 20px;">
									      <span class="visually-hidden">Loading...</span>
							      </div>
					           		لطفا شکیبا باشید
						        </button>
									  <button type="button" class="btn" style="margin-top:5px;width: 100%;background: transparent;color: #339595;"  @click="forgotPassword">فراموشی رمز عبور</button>
								  </div>
							  </form>
					  </div>
					  <button class="border-0 bg-transparent mb-2" style="width: 100%;color:rgb(22 93 93);font-size: .93em;" @click="goSign">عضو نشده اید؟<span class="text-primary">اینجا </span>کلیک کنید</button>
				  </div>
			  </div>
		  </div>
		   <forgot-modal></forgot-modal>
</template>
  
<script setup>
import axios from "axios";
import { ref,watch } from "vue";
import { convertToEnglish, convertToPersian } from "@/composables/digits.js";
import ForgotModal from "./BTN/forgot.vue";
import { alertBox } from "@/composables/silverBox";
let username = ref();
let password = ref();
let validMessage = ref();
let passwordTextFlag = ref("password");
let city = ref();
let finallFlag = ref(true)
remember();
watch(username,() => {
	username.value = convertToPersian(username.value)
	console.log(username.value);
})
watch(password,() => {
	password.value = convertToPersian(password.value)
})
function remember() {
	let remembering = localStorage.getItem("login");
	if (remembering != null) {
		remembering = JSON.parse(remembering);
		username.value = remembering.username;
		password.value = remembering.password;
	}
}
function entryUser() {
  if(username.value && password.value){
    finallFlag.value = false
    username.value = convertToEnglish(username.value)
    password.value = convertToEnglish(password.value)

    const formData = new FormData();
    formData.append('username', username.value);
    formData.append('password', password.value);

    axios.post("https://radap.ir/Backend/api/section/follow/entry_new.php", formData)
      .then(function (response) {
          if (response.data == "loss") {
            validMessage.value = "لطفا ابتدا ثبت نام نمایید";
            finallFlag.value = true
          } else if (response.data == "wrong") {
            validMessage.value = "لطفا رمز عبور خود را به درستی وارد نمایید";
            finallFlag.value = true
          } else {
            validMessage.value = "";
            if (document.getElementById("rememberInput").checked) {
              let login = {
                username: username.value,
                password: password.value,
              };
              localStorage.setItem("login", JSON.stringify(login));
            }
            let token = response.data
            localStorage.setItem('token',token)
            location.reload();
          }
      });
  }else if (!username.value) {
    alertBox("لطفا شماره همراه تان را وارد نمایید",'error');
    validMessage.value = "";
  } else if (!password.value) {
    alertBox("لطفا رمز عبور را وارد نمایید",'error');
    validMessage.value = "";
  }
}

function forgotPassword() {
  document.querySelector("#myModalCloseBTN").click();
  document.querySelector("#forgotModalBTN").click();
}
function goSign() {
  document.querySelector("#myModalCloseBTN").click();
  document.querySelector("#mobileModalBTN").click();
}
function passwordTextFunc() {
  if (passwordTextFlag.value == "password") {
    passwordTextFlag.value = "text";
  } else {
    passwordTextFlag.value = "password";
  }
}
</script>

<style>
  .modal-body.modal-body-sub_agile {
    padding: 0;
  }
  .null-border {
    border: 1px solid #e52121;
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
      rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  }
</style>
